import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { apiConstant } from '../app.constant';
import { JobRates } from '../app.model';

@Injectable({
  providedIn: 'root'
})
export class JobRatesService {

  constructor(private http: HttpClient) { }

  getJobRates() {
    let apiUrl = `${environment.baseUrl}` + apiConstant.JOB_RATES;
    return this.http.get<JobRates>(apiUrl);
  }
}
